module.exports = __webpack_public_path__ + "static/img/WechatIMG7@2x.04a596d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WechatIMG7@2x.png
// module id = ig+G
// module chunks = 3